/** Locale used by every date/time formatter in the app. */
export const APP_LOCALE = 'ru-RU' as const;

export function formatPct(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    const rounded = Number.isInteger(value) ? String(value) : value.toFixed(1);
    return `${rounded}%`;
}

export function formatConversion(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    return `${(value * 100).toFixed(1)}%`;
}

export function formatScore(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

export function formatDurationMin(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    const rounded = Number.isInteger(value) ? String(value) : value.toFixed(1);
    return `${rounded} мин`;
}

export function formatDate(d: Date): string {
    return d.toLocaleDateString(APP_LOCALE, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

export function formatDateShort(d: Date): string {
    return d.toLocaleDateString(APP_LOCALE);
}

export function formatTimeHm(d: Date): string {
    return d.toLocaleTimeString(APP_LOCALE, { hour: '2-digit', minute: '2-digit' });
}

export function formatDateTime(d: Date): string {
    return d.toLocaleString(APP_LOCALE, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function formatWeekdayShort(d: Date): string {
    return d.toLocaleDateString(APP_LOCALE, { weekday: 'short' });
}

export function formatDateBulletTime(d: Date): string {
    return `${formatDateShort(d)} • ${formatTimeHm(d)}`;
}

/** Timestamp used as a default profile title on create. */
export function formatProfileTitleTimestamp(d: Date): string {
    return d.toLocaleString(APP_LOCALE, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}
